import { rgbToCmyk, rgbToCss, rgbToHex, rgbToHsl, rgbToHsv } from ".";
import { round } from "../utils";
import { isValidXyz } from "../validators";
const validator = (xyz, converter) => {
    if (!isValidXyz(xyz))
        throw new Error(`${JSON.stringify(xyz)} is not an XYZ color value`);
    return converter;
};
const toRgb = (xyz) => {
    const _x = xyz.x / 100;
    const _y = xyz.y / 100;
    const _z = xyz.z / 100;
    let _r = _x * 3.2406 + _y * -1.5372 + _z * -0.4986;
    let _g = _x * -0.9689 + _y * 1.8758 + _z * 0.0415;
    let _b = _x * 0.0557 + _y * -0.2040 + _z * 1.0570;
    _r = _r > 0.0031308 ? 1.055 * Math.pow(_r, 0.41666) - 0.055 : 12.92 * _r;
    _g = _g > 0.0031308 ? 1.055 * Math.pow(_g, 0.41666) - 0.055 : 12.92 * _g;
    _b = _b > 0.0031308 ? 1.055 * Math.pow(_b, 0.41666) - 0.055 : 12.92 * _b;
    _r = round(_r * 255);
    _g = round(_g * 255);
    _b = round(_b * 255);
    return {
        r: _r < 0 ? 0 : _r > 255 ? 255 : _r,
        g: _g < 0 ? 0 : _g > 255 ? 255 : _g,
        b: _b < 0 ? 0 : _b > 255 ? 255 : _b
    };
};
const toCIELab = (xyz, options) => {
    const roundTo = (options === null || options === void 0 ? void 0 : options.roundTo) || 2;
    const xyzR = (options === null || options === void 0 ? void 0 : options.xyzRef) || { x: 95.047, y: 100.00, z: 108.883 };
    let _x = xyz.x / xyzR.x;
    let _y = xyz.y / xyzR.y;
    let _z = xyz.z / xyzR.z;
    _x = _x > 0.008856 ? Math.pow(_x, (1 / 3)) : (7.787 * _x) + (16 / 116);
    _y = _y > 0.008856 ? Math.pow(_y, (1 / 3)) : (7.787 * _y) + (16 / 116);
    _z = _z > 0.008856 ? Math.pow(_z, (1 / 3)) : (7.787 * _z) + (16 / 116);
    const lab = {
        l: round((116 * _y) - 16, roundTo),
        a: round(500 * (_x - _y), roundTo),
        b: round(200 * (_y - _z), roundTo)
    };
    lab.a = lab.a > 128 ? 128 : lab.a;
    lab.a = lab.a < -128 ? -128 : lab.a;
    lab.b = lab.b > 128 ? 128 : lab.b;
    lab.b = lab.b < -128 ? -128 : lab.b;
    return lab;
};
export const xyzToHex = (xyz) => validator(xyz, rgbToHex)(toRgb(xyz));
export const xyzToCss = (xyz, options) => validator(xyz, rgbToCss)(toRgb(xyz), options);
export const xyzToRgb = (xyz) => validator(xyz, toRgb)(xyz);
export const xyzToHsl = (xyz, options) => validator(xyz, rgbToHsl)(toRgb(xyz), options);
export const xyzToHsv = (xyz, options) => validator(xyz, rgbToHsv)(toRgb(xyz), options);
export const xyzToCmyk = (xyz) => validator(xyz, rgbToCmyk)(toRgb(xyz));
export const xyzToCIELab = (xyz, options) => validator(xyz, toCIELab)(xyz, options);
